export const COMPANY = {
  name: "Top C Group",
  legal: "Top C Group Sdn Bhd",
  ssm: "SSM 202601021906",
  tagline: ["Your sourcing &", "operations partner."],
  intro:
    "A Malaysia-registered trading and business services company. We connect vetted manufacturers in China with international brand partners — and run the operations behind the scenes.",
  email: "topctrading@gmail.com",
  phone: "+60 11-1128 0169",
  addressLines: [
    "Top C Group Sdn Bhd",
    "32, Jalan Ekoperniagaan 2/5,",
    "Taman Ekoperniagaan, 81100",
    "Johor Bahru, Johor, Malaysia",
  ],
  regions: ["United States", "United Kingdom", "Europe", "Australia", "New Zealand"],
};

export const TRUST = [
  "Malaysia Registered Company",
  "International Supply Chain",
  "Dedicated Support Team",
  "Quality-Controlled Sourcing",
  "End-to-End Operations",
];

export const SERVICES = [
  {
    id: "sourcing",
    no: "01",
    title: "Sourcing & Procurement",
    short: "Supplier management, quality control & consolidated purchasing.",
    body:
      "We identify, vet and manage manufacturers across China, negotiating on your behalf and consolidating purchasing to reduce cost and complexity.",
    points: [
      "Supplier discovery & due diligence",
      "On-the-ground quality control & inspection",
      "Consolidated purchasing & cost negotiation",
      "Compliance & consumer-safety documentation",
    ],
  },
  {
    id: "trading",
    no: "02",
    title: "Trading & Supply",
    short: "Wholesale supply to international brand partners.",
    body:
      "As your trading intermediary, we supply consumer safety products at wholesale to brand partners across the US, UK, Europe, Australia and New Zealand.",
    points: [
      "Wholesale supply agreements",
      "International logistics coordination",
      "Inventory & lead-time planning",
      "Cross-border trade documentation",
    ],
  },
  {
    id: "operations",
    no: "03",
    title: "Marketing & Operations Support",
    short: "Ad management, customer service & fulfillment coordination.",
    body:
      "We run the day-to-day operations for our partners — from advertising management to customer service and order-fulfillment coordination.",
    points: [
      "Advertising & marketing management",
      "Customer service & helpdesk",
      "Order processing & tracking",
      "Fulfillment coordination",
    ],
  },
];
